import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { class: "w90 pad15" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "fl w30 pad10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "アドレス帳", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " アドレス帳グループを作成しておくことで、毎回選択しなくても決められたメンバーに一斉にメールを送信することが可能になります。 ", -1)
const _hoisted_9 = {
  key: 0,
  class: "fl w65"
}
const _hoisted_10 = { class: "fl w100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fl" }, "新規に追加", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw600 fl",
  style: {"margin-bottom":"0","margin-left":"-3px"}
}, " 一括アップロード", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "事前にアドレス帳に追加しておくことができます。", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "w100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fs11" }, "キャンセル", -1)
const _hoisted_27 = {
  key: 0,
  class: "fl w65"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt20" }, "アドレス帳グループを作成", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "fl w65"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt10" }, "編集するアドレス帳グループを選択", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  class: "fl mt20",
  style: {"width":"300px"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "fs11 fw600" }, "グループ内共有メモ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = {
  key: 3,
  class: "w100"
}
const _hoisted_39 = { class: "fl w45" }
const _hoisted_40 = { class: "fl w45" }
const _hoisted_41 = {
  key: 0,
  class: "lgreyBg rad20 pad20 mt40 centered"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "grey mt10" }, [
  /*#__PURE__*/_createTextVNode(" グループに登録されたメンバーはいません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("アドレス帳よりグループに登録したいメンバーを選択してください。 ")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "mt40"
}
const _hoisted_46 = { class: "w100" }
const _hoisted_47 = {
  key: 0,
  class: "fl arial"
}
const _hoisted_48 = {
  class: "fs28 fw600",
  style: {"margin-left":"12px"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "人登録", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = { class: "fr" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = { class: "lgreyBg rad20 pad20 mt20" }
const _hoisted_55 = {
  class: "fs14 fw600 pad10",
  style: {"width":"calc(100% - 30px)"}
}
const _hoisted_56 = { class: "fl" }
const _hoisted_57 = {
  key: 0,
  class: "fs10"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = { class: "grey fs9" }
const _hoisted_60 = {
  key: 0,
  class: "fl mr5 mt2"
}
const _hoisted_61 = {
  class: "fr",
  style: {"width":"160px"}
}
const _hoisted_62 = {
  style: {"width":"35px","margin-right":"5%"},
  class: "fr"
}
const _hoisted_63 = ["src", "onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttendeeForm = _resolveComponent("AttendeeForm")!
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_ModalUpload = _resolveComponent("ModalUpload")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.selectedTab == `address_book`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", {
                class: "pointer centered circle_button skyblueBg fs12 rad8 mt15 ml20 fw600",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createContactListGroup && _ctx.createContactListGroup(...args)))
              }, " アドレス帳グループを作成 "),
              _createElementVNode("div", {
                class: "pointer centered circle_button skyblueBg fs12 rad8 mt15 ml20 fw600",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editContactListGroup && _ctx.editContactListGroup(...args)))
              }, " アドレス帳グループを編集 ")
            ]),
            (_ctx.selectedTab == `address_book`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("section", {
                    class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("label", {
                        class: _normalizeClass(`circle_button fw400 fl centered fs12 blueAround`),
                        style: {"width":"150px","padding":"4px 10px","margin-left":"30px","margin-top":"-5px","border":"0"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openUploadModal && _ctx.openUploadModal(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/select_file.png`),
                          width: "18",
                          height: "23",
                          style: {"margin-top":"-2px"},
                          class: "fl"
                        }, null, 8, _hoisted_12),
                        _hoisted_13
                      ]),
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_AttendeeForm, {
                          currentMember: _ctx.currentMember,
                          action: _ctx.editOrNewForm,
                          type: `horizontal`,
                          onUpdate: _ctx.addAttendeeFromUnderBox
                        }, null, 8, ["currentMember", "action", "onUpdate"]),
                        _hoisted_19,
                        _hoisted_20
                      ]),
                      _hoisted_21,
                      _hoisted_22
                    ]),
                    _hoisted_23
                  ], 2),
                  _createElementVNode("section", null, [
                    (_ctx.rm.userInfo)
                      ? (_openBlock(), _createBlock(_component_AddressBookContent, {
                          key: 0,
                          style: `margin-top:20px;padding:20px;`,
                          members: [],
                          currentMember: _ctx.currentMember,
                          editOrNewForm: _ctx.editOrNewForm,
                          showEditButton: true,
                          showNewButton: false,
                          editGroup: true,
                          onEditAttendee: _ctx.editAttendee,
                          onDeleteUser: _ctx.deleteUser
                        }, null, 8, ["currentMember", "editOrNewForm", "onEditAttendee", "onDeleteUser"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : ([`new_group`, `edit_group`].includes(_ctx.selectedTab))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("a", {
                class: "posRe fr pointer centered",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEditGroup && _ctx.cancelEditGroup(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                  width: "50",
                  height: "50"
                }, null, 8, _hoisted_25),
                _hoisted_26
              ]),
              (_ctx.selectedTab == `new_group`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                : _createCommentVNode("", true),
              (_ctx.selectedTab == `edit_group`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (!_ctx.edittingGroup)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode(_component_SelectTag, {
                            name: "span_repo_months",
                            id: "select_repo_months",
                            class: "fl fs14 roundForm mr5 mt20",
                            style: {"min-width":"250px","height":"50px"},
                            options: _ctx.clgs.map(clg => clg.name),
                            needUnselect: true,
                            onSelectValue: _ctx.selectEditGroup
                          }, null, 8, ["options", "onSelectValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true),
              (_ctx.edittingGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:280px;max-width:100%;",
                      style: {"height":"56px","min-width":"280px","max-width":"50%"},
                      class: "fl fs16 ml20 mr20",
                      type: `newGroupName`,
                      placeholder: `社内営業部門用`,
                      value: _ctx.edittingGroup.name,
                      onInputValue: _ctx.inputNewGroupName
                    }, null, 8, ["value", "onInputValue"]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_TextareaTag, {
                        placeholder: "社内面談メンバー一斉送信する際にこちらを利用します。",
                        class: "fs14 roundForm mw100 rad20 llgreyBg",
                        style: `height:80px;padding:10px;`,
                        value: _ctx.edittingGroup.private_memo,
                        onInputValue: _ctx.inputPrivateMemo
                      }, null, 8, ["value", "onInputValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_37,
              (_ctx.edittingGroup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.rm.userInfo)
                        ? (_openBlock(), _createBlock(_component_AddressBookContent, {
                            key: 0,
                            style: `margin-top:20px;padding:20px;`,
                            members: [],
                            currentMember: _ctx.currentMember,
                            editOrNewForm: _ctx.editOrNewForm,
                            showEditButton: false,
                            showNewButton: false,
                            editGroup: false,
                            hideGroups: true,
                            onEditAttendee: _ctx.editAttendee,
                            onDeleteUser: _ctx.deleteUser,
                            onAddAttendee: _ctx.addAttendeeForGroup
                          }, null, 8, ["currentMember", "editOrNewForm", "onEditAttendee", "onDeleteUser", "onAddAttendee"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (!_ctx.edittingGroup.contact_lists || _ctx.edittingGroup.contact_lists.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                              width: "40",
                              height: "40"
                            }, null, 8, _hoisted_42),
                            _hoisted_43,
                            _hoisted_44
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              (_ctx.edittingGroup.contact_lists)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.edittingGroup.contact_lists.length), 1),
                                    _hoisted_49,
                                    _hoisted_50
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", {
                                  class: "pointer centered circle_button skyblueBg fs12 rad8 ml20 fw600",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveGroup && _ctx.saveGroup(...args)))
                                }, " 保存 ")
                              ]),
                              _hoisted_52
                            ]),
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edittingGroup.contact_lists, (mem, memindex) => {
                                return (_openBlock(), _createElementBlock("div", { key: memindex }, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createVNode(_component_UserIcon, {
                                      member: mem,
                                      width: 38,
                                      canEdit: false,
                                      updateSelf: false,
                                      showTooltip: false,
                                      class: "fl mr3 mr10"
                                    }, null, 8, ["member"]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("span", null, _toDisplayString(mem.name), 1),
                                      (mem.company_name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "(" + _toDisplayString(mem.company_name) + ")", 1))
                                        : _createCommentVNode("", true),
                                      _hoisted_58,
                                      _createElementVNode("div", _hoisted_59, [
                                        (!_ctx.Util.isSMSEmail(mem.email))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.truncate(mem.email, 25)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                                          width: "30",
                                          height: "30",
                                          class: "fr pointer",
                                          onClick: ($event: any) => (_ctx.removeMemberFromGroup(mem))
                                        }, null, 8, _hoisted_63),
                                        _createTextVNode("   ")
                                      ])
                                    ]),
                                    _hoisted_64
                                  ])
                                ]))
                              }), 128))
                            ]),
                            _hoisted_65
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
      _hoisted_66
    ]),
    _hoisted_67,
    _createVNode(_component_ModalUpload, {
      onUploadedFile: _ctx.uploadedFile,
      type: `addressbook`
    }, null, 8, ["onUploadedFile"]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: `${_ctx.rm.showPlanOptionModalWithName} 課金リクエスト`,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel,
      onCloseModal: _ctx.closeOptionModal
    }, null, 8, ["eventName", "onClickOK", "onClickCancel", "onCloseModal"])
  ]))
}